import React from 'react';
import MkPhone from '../MkPhone';
import MkPill from '../MkPill';
import bmbIntention from '../../../assets/images/mk/mk-bmb-intention-540.webp';

const FREE = [
  { name: '4-7-8 breathing', time: 'About 1 minute', line: 'Breathe in for 4, hold for 7, breathe out for 8.' },
  { name: 'Quote', time: 'About 10 seconds', line: 'A short line to read before you continue.' },
  { name: 'Delay', time: '15 seconds', line: 'A 15-second countdown before you continue.' },
];

const PREMIUM = [
  { name: 'Box breathing', time: 'About 1 minute', line: 'Breathe in, hold, out and hold — 4 counts each.' },
  { name: 'Intention', time: 'About 15 seconds', line: 'One question: What do you actually need?' },
  {
    name: '5-4-3-2-1 grounding',
    time: 'About 2 minutes',
    line: 'Start by naming 5 things you can see, and work down to 1.',
  },
  { name: 'Gratitude', time: 'About 1 minute', line: "Name three things you're grateful for." },
];

const PauseCards = ({ items, offset }) =>
  items.map((p, i) => (
    <li
      key={p.name}
      className="mk-pause reveal-from-bottom"
      data-reveal-container=".mk-pauses__grid"
      data-reveal-delay={(offset + i) * 50}
    >
      <div className="mk-card mk-pause__card">
        <p className="mk-pause__name">{p.name}</p>
        <p className="mk-pause__time">{p.time}</p>
        <p className="mk-body mk-pause__line">{p.line}</p>
      </div>
    </li>
  ));

// B3 — the seven pause types, split honestly into Free and Premium.
const BmbPauses = () => (
  <section className="mk-pauses section" id="pauses" aria-labelledby="mk-pauses-title">
    <div className="container">
      <div className="mk-pauses__inner section-inner">
        <div className="mk-pauses__main">
          <div className="mk-head mk-head--left reveal-from-bottom">
            <h2 id="mk-pauses-title" className="mk-h2">
              Seven ways to pause
            </h2>
            <p className="mk-lead">Pick a different pause for each app.</p>
          </div>
          <div className="mk-pauses__grid">
            <div className="mk-pauses__group">
              <h3 className="mk-pauses__label">
                <MkPill variant="free">Free</MkPill>
              </h3>
              <ul className="list-reset mk-pauses__list mk-pauses__list--free">
                <PauseCards items={FREE} offset={0} />
              </ul>
            </div>
            <div className="mk-pauses__group">
              <h3 className="mk-pauses__label">
                <MkPill variant="premium">Premium</MkPill>
              </h3>
              <ul className="list-reset mk-pauses__list mk-pauses__list--premium">
                <PauseCards items={PREMIUM} offset={3} />
              </ul>
            </div>
          </div>
        </div>
        <div className="mk-pauses__visual">
          <div className="mk-drift">
            <div className="mk-float">
              <MkPhone
                src={bmbIntention}
                width={540}
                height={1095}
                framed
                alt={'Bring Me Back intention pause before Instagram asking "What do you actually need from Instagram right now?"'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbPauses;
